// removed by extract-text-webpack-plugin
module.exports = {"WorkInfoArticle":"workInfo__WorkInfoArticle--2Y40C","Patentinfo":"workInfo__Patentinfo--3Q9IW","p1":"workInfo__p1--3ZZxd","p2":"workInfo__p2--30SW9","WorkInfo":"workInfo__WorkInfo--8R5mK"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Collector/work-principle/workInfo.css
// module id = 62
// module chunks = 0